import { render, staticRenderFns } from "./ModelCardView.vue?vue&type=template&id=b6decb5a&"
import script from "./ModelCardView.vue?vue&type=script&lang=js&"
export * from "./ModelCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModelCardView.vue"
export default component.exports